define("shared/components/shared/profile-categorization/rewards-steps/report/full", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--m__b__xs u--text--light u--text--center">
    {{t (concat @prefix "industry_insights")}}
  </p>
  
  <a class="u--block u--text--center qa--categorize_back" {{on "click" (fn @clearSelectedCategory "rewards")}}>
    {{t "profile_categorization.categorize_form.change_selection"}}
  </a>
  
  <h2 class="tSC--card__title u--text--center">
    {{t (concat "profile_categorization.industries." @socialProfile.industry)}}
  </h2>
  
  <div class="tSC--result">
    <div class="o--cardBody u--p__xs">
      {{#if @profileReportData.hasEnoughHashtags}}
        <ul class="tOB--nav o--nav--underline">
          <li class="o--nav__item tOB--nav__item">
            <a
              class="o--nav__link {{if (eq @currentTabNum 1) 'is--active' ''}} qa--categorize_reports_change_tab_1"
              {{on "click" (fn @changeTabNum 1)}}
            >
              {{t (concat @prefix "engagement_distribution.tab_name")}}
            </a>
          </li>
          <li class="o--nav__item tOB--nav__item">
            <a
              class="o--nav__link {{if (eq @currentTabNum 2) 'is--active' ''}} qa--categorize_reports_change_tab_2"
              {{on "click" (fn @changeTabNum 2)}}
            >
              {{t (concat @prefix "hashtag_usage.tab_name")}}
            </a>
          </li>
        </ul>
  
        {{#if (eq @currentTabNum 1)}}
          <Shared::ProfileCategorization::RewardsSteps::Tab::EngagementDistribution
            @industryEngagement={{@industryReportData.averageIndustryEngagement}}
            @isLoading={{or @profileReportData.isLoading @industryReportData.isLoading}}
            @limits={{@industryReportData.industryEngagementLimits}}
            @profileEngagement={{@profileReportData.averageProfileEngagement}}
            @sectionName={{@sectionName}}
            @socialProfile={{@socialProfile}}
            @triggerSegmentEvent={{fn this.trackViewedIndustryComparison @currentTabNum}}
          />
        {{else if (eq @currentTabNum 2)}}
          <Shared::ProfileCategorization::RewardsSteps::Tab::HashtagUsage
            @industryHashtags={{@industryReportData.industryHashtags}}
            @isLoading={{or @profileReportData.isLoading @industryReportData.isLoading}}
            @profileHashtags={{@profileReportData.profileHashtags}}
            @sectionName={{@sectionName}}
            @showPartialRewards={{false}}
            @socialProfile={{@socialProfile}}
            @triggerSegmentEvent={{fn this.trackViewedIndustryComparison @currentTabNum}}
          />
        {{/if}}
      {{else}}
        <Shared::ProfileCategorization::RewardsSteps::Tab::EngagementDistribution
          @industryEngagement={{@industryReportData.averageIndustryEngagement}}
          @isLoading={{or @profileReportData.isLoading @industryReportData.isLoading}}
          @limits={{@industryReportData.industryEngagementLimits}}
          @profileEngagement={{@profileReportData.averageProfileEngagement}}
          @sectionName={{@sectionName}}
          @socialProfile={{@socialProfile}}
          @triggerSegmentEvent={{fn this.trackViewedIndustryComparison @currentTabNum}}
        />
      {{/if}}
    </div>
  </div>
  
  <Shared::Ui::Button
    @additional="block"
    @onClick={{fn @exitCategorization false}}
    @size="regular"
    class="qa--categorize_reports_exit"
  >
    {{#if @isModalFlow}}
      {{t "shared_words.done"}}
    {{else}}
      {{t "authorization.sign_up_success.finish_setup"}}
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "3J9O4yRe",
    "block": "[[[10,2],[14,0,\"u--m__b__xs u--text--light u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[[30,1],\"industry_insights\"],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[11,3],[24,0,\"u--block u--text--center qa--categorize_back\"],[4,[38,2],[\"click\",[28,[37,3],[[30,2],\"rewards\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"profile_categorization.categorize_form.change_selection\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"h2\"],[14,0,\"tSC--card__title u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[\"profile_categorization.industries.\",[30,3,[\"industry\"]]],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tSC--result\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--cardBody u--p__xs\"],[12],[1,\"\\n\"],[41,[30,4,[\"hasEnoughHashtags\"]],[[[1,\"      \"],[10,\"ul\"],[14,0,\"tOB--nav o--nav--underline\"],[12],[1,\"\\n        \"],[10,\"li\"],[14,0,\"o--nav__item tOB--nav__item\"],[12],[1,\"\\n          \"],[11,3],[16,0,[29,[\"o--nav__link \",[52,[28,[37,5],[[30,5],1],null],\"is--active\",\"\"],\" qa--categorize_reports_change_tab_1\"]]],[4,[38,2],[\"click\",[28,[37,3],[[30,6],1],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,0],[[28,[37,1],[[30,1],\"engagement_distribution.tab_name\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"o--nav__item tOB--nav__item\"],[12],[1,\"\\n          \"],[11,3],[16,0,[29,[\"o--nav__link \",[52,[28,[37,5],[[30,5],2],null],\"is--active\",\"\"],\" qa--categorize_reports_change_tab_2\"]]],[4,[38,2],[\"click\",[28,[37,3],[[30,6],2],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,0],[[28,[37,1],[[30,1],\"hashtag_usage.tab_name\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[28,[37,5],[[30,5],1],null],[[[1,\"        \"],[8,[39,6],null,[[\"@industryEngagement\",\"@isLoading\",\"@limits\",\"@profileEngagement\",\"@sectionName\",\"@socialProfile\",\"@triggerSegmentEvent\"],[[30,7,[\"averageIndustryEngagement\"]],[28,[37,7],[[30,4,[\"isLoading\"]],[30,7,[\"isLoading\"]]],null],[30,7,[\"industryEngagementLimits\"]],[30,4,[\"averageProfileEngagement\"]],[30,8],[30,3],[28,[37,3],[[30,0,[\"trackViewedIndustryComparison\"]],[30,5]],null]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,5],[[30,5],2],null],[[[1,\"        \"],[8,[39,8],null,[[\"@industryHashtags\",\"@isLoading\",\"@profileHashtags\",\"@sectionName\",\"@showPartialRewards\",\"@socialProfile\",\"@triggerSegmentEvent\"],[[30,7,[\"industryHashtags\"]],[28,[37,7],[[30,4,[\"isLoading\"]],[30,7,[\"isLoading\"]]],null],[30,4,[\"profileHashtags\"]],[30,8],false,[30,3],[28,[37,3],[[30,0,[\"trackViewedIndustryComparison\"]],[30,5]],null]]],null],[1,\"\\n      \"]],[]],null]],[]]]],[]],[[[1,\"      \"],[8,[39,6],null,[[\"@industryEngagement\",\"@isLoading\",\"@limits\",\"@profileEngagement\",\"@sectionName\",\"@socialProfile\",\"@triggerSegmentEvent\"],[[30,7,[\"averageIndustryEngagement\"]],[28,[37,7],[[30,4,[\"isLoading\"]],[30,7,[\"isLoading\"]]],null],[30,7,[\"industryEngagementLimits\"]],[30,4,[\"averageProfileEngagement\"]],[30,8],[30,3],[28,[37,3],[[30,0,[\"trackViewedIndustryComparison\"]],[30,5]],null]]],null],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,9],[[24,0,\"qa--categorize_reports_exit\"]],[[\"@additional\",\"@onClick\",\"@size\"],[\"block\",[28,[37,3],[[30,9],false],null],\"regular\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,10],[[[1,\"    \"],[1,[28,[35,0],[\"shared_words.done\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,0],[\"authorization.sign_up_success.finish_setup\"],null]],[1,\"\\n\"]],[]]]],[]]]]]],[\"@prefix\",\"@clearSelectedCategory\",\"@socialProfile\",\"@profileReportData\",\"@currentTabNum\",\"@changeTabNum\",\"@industryReportData\",\"@sectionName\",\"@exitCategorization\",\"@isModalFlow\"],false,[\"t\",\"concat\",\"on\",\"fn\",\"if\",\"eq\",\"shared/profile-categorization/rewards-steps/tab/engagement-distribution\",\"or\",\"shared/profile-categorization/rewards-steps/tab/hashtag-usage\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report/full.hbs",
    "isStrictMode": false
  });
  let FullComponent = _exports.default = (_class = class FullComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "segment", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
    }
    trackViewedIndustryComparison(tabNum) {
      const {
        sectionName,
        socialProfile
      } = this.args;
      const {
        id,
        isBusiness,
        category,
        industry,
        businessModel,
        nickname
      } = socialProfile;
      try {
        this.segment.track('viewed-industry-comparison-self-cat', {
          area: sectionName,
          profile: id,
          is_business: isBusiness,
          category,
          industry,
          bus_model: businessModel,
          tab: tabNum === 1 ? 'engagement' : 'hashtags',
          social_profile_nickname: nickname
        });
      } catch (error) {
        this.errors.log(new Error(`Error Tracking viewed-industry-comparison-self-cat from location ${this.args.sectionName}`), error);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "trackViewedIndustryComparison", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackViewedIndustryComparison"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FullComponent);
});